import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useAppServices } from "../../../hook/services";
import { useUsersContext } from "../../../context/usersContext";
import { useUserInfo } from "../../../context/user";
import toast from "react-hot-toast";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import AuthTopBar from "../component/AuthTopBar";
import DoneIcon from "@mui/icons-material/Done";

const AddPayment = () => {
  const [agency, setAgency] = useState();
  const logout = useUserInfo()[2];
  const navigate = useNavigate();
  const service = useAppServices();
  const [, , , saveActiveLocation, userActiveLocation] = useUserInfo();
  const [loading, setLoading] = useState(true);
  const [accountLoading, setAccountLoading] = useState(false);
  const [plandata, setPlanData] = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(null);
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);

  const fetchAgency = async () => {
    const { response } = await service.agency.getAgency({
      query: `_id=${userActiveLocation?.agency_id}`,
    });
    const { response: planDetails } = await service.saas.fetchPlanById({
      query: `id=${userActiveLocation?.plan_id}`,
    });
    if (response?.data) setAgency(response?.data);
    if (planDetails?.data) setPlanData(planDetails?.data);
    setLoading(false);
  };

  useEffect(() => {
    if (userActiveLocation?.agency_id) fetchAgency();
  }, [userActiveLocation]);

  // Handle Carousel Timer
  useEffect(() => {
    if (!agency?.account_activation_quote) return;

    let quotesCount = 0;
    try {
      const parsed =
        typeof agency.account_activation_quote === "string"
          ? JSON.parse(agency.account_activation_quote)
          : agency.account_activation_quote;
      if (parsed.quote1?.text) quotesCount++;
      if (parsed.quote2?.text) quotesCount++;
      if (parsed.quote3?.text) quotesCount++;
    } catch (e) {
      return;
    }

    if (quotesCount <= 1) return;

    const interval = setInterval(() => {
      setCurrentQuoteIndex((prev) => (prev + 1) % quotesCount);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (plandata?.is_free_saas) {
      if (
        plandata.promptlabel_ids?.length > 0 &&
        userActiveLocation?.assistants?.length === 0
      ) {
        handleAddAssistantsInAccount();
      } else {
        navigate("/app/chat");
      }
    }
  }, [plandata]);

  const handleAddAssistantsInAccount = async () => {
    setAccountLoading(true);
    const { response, error } = await service.accounts.update({
      payload: {
        _id: userActiveLocation?.id,
        promptlabels_ids: plandata?.promptlabel_ids,
      },
    });
    if (response?.data) {
      saveActiveLocation({
        ...userActiveLocation,
        ...response?.account,
      });
    }
    setAccountLoading(false);
    navigate("/app/chat");
  };

  if (!agency?.stripe?.publish_key || accountLoading) {
    return (
      <div className="h-screen bg-white">
        <AuthTopBar />
        <div className="relative flex justify-center">
          {/* <p className="text-[#757575] absolute top-7 right-12">
            Already have an account?{" "}
            <button
              className="text-[#1E1E1E]"
              onClick={() => {
                logout();
                navigate("/auth/sign-in");
              }}
            >
              Sign in
            </button>
          </p> */}
          {loading || accountLoading ? (
            <div className="spinner !w-30 !h-30 mt-28"></div>
          ) : (
            <p className="text-red-500 mt-28">
              Stripe publish key is not available.
            </p>
          )}
        </div>
      </div>
    );
  }
  const stripePromise = loadStripe(agency?.stripe?.publish_key);

  const calculations = () => {
    return userActiveLocation?.planType === "monthly"
      ? !couponDiscount
        ? plandata?.monthly_amount / 100
        : couponDiscount?.coupon?.percent_off
          ? plandata?.monthly_amount / 100 -
            (couponDiscount?.coupon?.percent_off / 100) *
              (plandata?.monthly_amount / 100)
          : plandata?.monthly_amount / 100 -
            parseInt(couponDiscount?.coupon?.amount_off) / 100
      : !couponDiscount
        ? plandata?.yearly_amount / 100
        : couponDiscount?.coupon?.percent_off
          ? plandata?.yearly_amount / 100 -
            (couponDiscount?.coupon?.percent_off / 100) *
              (plandata?.yearly_amount / 100)
          : plandata?.yearly_amount / 100 -
            parseInt(couponDiscount?.coupon?.amount_off) / 100;
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="relative">
        <AuthTopBar />
        <p className="text-[#757575] absolute top-1/2 -translate-y-1/2 right-12 text-sm hidden md:block">
          Already have an account?{" "}
          <button
            className="text-[#1E1E1E] font-semibold hover:underline"
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
          >
            Sign In
          </button>
        </p>
      </div>

      <div className="flex-1 flex flex-col md:flex-row">
        {/* Left side - form */}
        <div className="w-full md:w-1/2 flex flex-col items-center py-12 px-6 md:py-20">
          <div className="max-w-[440px] w-full">
            {plandata?.trial_and_credit?.active_trile_period ? (
              <h2 className="text-[34px] font-bold mb-4 leading-tight">
                {`Start Your ${plandata?.trial_and_credit?.days} Day Free Trial`}
              </h2>
            ) : (
              <h2 className="text-[34px] font-bold mb-4 leading-tight">
                Activate Your Account And <br />
                Build AI Agents Without Limits
              </h2>
            )}
            <div className="text-gray-600 text-[17px] mb-10 leading-relaxed">
              {plandata?.trial_and_credit?.active_trile_period ? (
                <>
                  <p className="mb-4">
                    Add your card details to turn ideas into AI Agents in
                    minutes. No charge today.
                  </p>
                  <p className="font-medium">Cancel anytime. No risk.</p>
                </>
              ) : (
                <p>
                  Give your team unlimited AI Agents, instant access to every
                  tool, and founder-led coaching that gets results fast.
                </p>
              )}
            </div>

            <Elements stripe={stripePromise}>
              <StripeForm
                agency={agency}
                userActiveLocation={userActiveLocation}
                setCouponDiscount={setCouponDiscount}
                plandata={plandata}
              />
            </Elements>

            {plandata?.trial_and_credit?.days ? (
              <p className="text-xs text-center text-gray-400 mt-8">
                No payment for {plandata?.trial_and_credit?.days || "x"} days.
                Then{" "}
                {plandata?.category?.name === "GBP"
                  ? "£"
                  : plandata?.category?.name === "USD"
                    ? "$"
                    : "£"}
                {calculations()}{" "}
                {`per ${
                  userActiveLocation?.planType === "monthly" ? "month" : "year"
                }. Cancel anytime`}
              </p>
            ) : (
              <p className="text-xs text-center text-gray-400 mt-8">
                {plandata?.category?.name === "GBP"
                  ? "£"
                  : plandata?.category?.name === "USD"
                    ? "$"
                    : "£"}
                {calculations()}{" "}
                {`per ${
                  userActiveLocation?.planType === "monthly" ? "month" : "year"
                }. Cancel anytime.`}
              </p>
            )}
          </div>
        </div>

        {/* Right side - benefits & testimonials */}
        <div className="w-full md:w-1/2 bg-[#F5F5F5] flex flex-col items-center py-12 px-6 md:py-20 gap-8">
          {/* Key Benefits Card */}
          <div className="bg-white rounded-md  shadow-md p-8 md:p-10 max-w-[480px] w-full">
            <h3 className="font-bold text-lg mb-8">Key Benefits</h3>
            <ul className="space-y-6">
              {[
                "Deploy prebuilt AI Agents",
                "Test real-world AI use cases in your business before you commit",
                "Join daily workshops with our founders",
                "ROI Playbook + Assessor Agent included",
                "24/7 Support",
              ].map((benefit, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-[#869afd] mr-4 mt-0.5">
                    <DoneIcon fontSize="small" />
                  </span>
                  <p className="text-gray-700 text-[15px] leading-snug">
                    {agency?.keyBenefits?.[idx] || benefit}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Account Activation Quotes */}
          {(() => {
            let quotes = [];
            try {
              if (agency?.account_activation_quote) {
                const parsed =
                  typeof agency.account_activation_quote === "string"
                    ? JSON.parse(agency.account_activation_quote)
                    : agency.account_activation_quote;

                if (parsed.quote1?.text) quotes.push(parsed.quote1);
                if (parsed.quote2?.text) quotes.push(parsed.quote2);
                if (parsed.quote3?.text) quotes.push(parsed.quote3);
              }
            } catch (e) {
              console.error("Error parsing quotes", e);
            }

            if (quotes.length === 0) return null;

            const activeQuote = quotes[currentQuoteIndex] || quotes[0];

            return (
              <div className="max-w-[480px] w-full">
                <div className="bg-white rounded-md  shadow-md p-8 md:p-10 flex flex-col justify-between min-h-[250px] transition-all duration-500">
                  <h3 className="text-gray-800 text-lg mb-8 leading-relaxed font-medium">
                    "{activeQuote.text}"
                  </h3>

                  <div className="flex items-center">
                    {activeQuote.image && (
                      <div className="w-12 h-12 mr-4 rounded-full overflow-hidden bg-gray-100 shrink-0">
                        <img
                          src={activeQuote.image}
                          alt={activeQuote.author_name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}

                    <div>
                      {activeQuote.author_name && (
                        <p className="font-bold text-sm text-gray-900">
                          {activeQuote.author_name}
                        </p>
                      )}
                      {activeQuote.job_title && (
                        <p className="text-xs text-gray-500 mt-0.5">
                          {activeQuote.job_title}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Carousel Dots */}
                  {quotes.length > 1 && (
                    <div className="flex justify-center gap-2 mt-8">
                      {quotes.map((_, idx) => (
                        <button
                          key={idx}
                          onClick={() => setCurrentQuoteIndex(idx)}
                          className={`w-2 h-2 rounded-full transition-all duration-300 ${
                            currentQuoteIndex === idx
                              ? "bg-[#869afd]"
                              : "bg-gray-200 hover:bg-gray-300"
                          }`}
                          aria-label={`Go to quote ${idx + 1}`}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

export default AddPayment;

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: "16px",
      color: "#1f2937",
      fontFamily: '"Inter", sans-serif',
      "::placeholder": {
        color: "#9ca3af",
      },
    },
    invalid: {
      color: "#ef4444",
    },
  },
};

const StripeForm = ({
  agency,
  userActiveLocation,
  setCouponDiscount,
  plandata,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [coupon, setCoupon] = useState("");
  const [postcode, setPostcode] = useState("");
  const service = useAppServices();
  const saveActiveLocation = useUserInfo()[5];
  const userInfo = useUserInfo()[0];
  const navigate = useNavigate();

  useEffect(() => {
    if (plandata?.is_free_saas) {
      if (
        plandata.promptlabel_ids?.length > 0 &&
        userActiveLocation?.assistants?.length === 0
      ) {
        handleAddAssistantsInAccount();
      } else {
        navigate("/app/chat");
      }
    }
  }, [plandata]);

  const handleAddAssistantsInAccount = async () => {
    const { response, error } = await service.assistant.update({
      payload: {
        _id: userActiveLocation?.id,
        promptlabels_ids: plandata?.promptlabel_ids,
      },
    });
    if (response?.data) {
      saveActiveLocation({
        ...userActiveLocation,
        ...response.data,
      });
    }
    navigate("/app/chat");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!stripe || !elements) {
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name,
        email: userActiveLocation?.email,
        address: {
          postal_code: postcode,
        },
      },
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    const { response, error: paymentErrors } =
      await service.subscription.updatePaymentMethodByAgencyId({
        payload: {
          id: paymentMethod.id,
          agency_id: agency?._id,
          customer_id: userActiveLocation?.customer_id,
        },
      });
    if (response?.data) {
      const { response: paymentResp, error } =
        await service.subscription.createSubscription({
          payload: {
            agency_id: agency?._id,
            price_id:
              userActiveLocation?.planType === "monthly"
                ? plandata?.monthly_id
                : plandata?.yearly_id,
            plan_id: plandata?._id,
            account_id: userActiveLocation?._id,
            paymentMethod_id: paymentMethod.id,
            customer_id: userActiveLocation?.customer_id,
            code: coupon,
            userId: userInfo?._id,
          },
        });
      if (paymentResp?.data) {
        const subscription = paymentResp.data;
        const latestInvoice = subscription.latest_invoice;
        const paymentIntent = latestInvoice?.payment_intent;

        if (
          paymentIntent &&
          (paymentIntent.status === "requires_action" ||
            paymentIntent.status === "requires_confirmation")
        ) {
          const { error: confirmError } = await stripe.confirmCardPayment(
            paymentIntent.client_secret,
          );

          if (confirmError) {
            toast.error(confirmError.message);
            return;
          }
        }

        saveActiveLocation(paymentResp.account);
        toast.success("Subscription created successfully!");
        setTimeout(() => {
          navigate("/app/chat");
        }, 300);
      }

      if (error?.message?.includes("incomplete")) {
        const subscription = error.data;
        const latestInvoice = subscription.latest_invoice;
        const paymentIntent = latestInvoice?.payment_intent;
        if (
          paymentIntent &&
          (paymentIntent.status === "requires_action" ||
            paymentIntent.status === "requires_confirmation")
        ) {
          const { error: confirmError } = await stripe.confirmCardPayment(
            paymentIntent.client_secret,
          );

          if (confirmError) {
            toast.error(confirmError.message);
            return;
          }
        }

        saveActiveLocation(error.account);
        toast.success("Subscription created successfully!");
        setTimeout(() => {
          navigate("/app/chat");
        }, 300);
        return;
      }
      if (error?.message?.includes("Already have an active subscription")) {
        saveActiveLocation(error.account);
        setTimeout(() => {
          navigate("/app/chat");
        }, 300);
      }
    }
    if (paymentErrors?.message)
      toast.error(
        paymentErrors?.message === "Your card was declined."
          ? "Your card was declined. please try with another"
          : paymentErrors.message,
        "error",
      );
    setLoading(false);
  };

  const handleApplycoupon = async (e) => {
    e.stopPropagation();
    if (!coupon) return;
    setCouponLoading(true);
    const { response, error } = await service.coupons.applyCoupon({
      payload: {
        userId: userActiveLocation?._id,
        code: coupon,
        agency_id: userActiveLocation?.agency_id,
      },
    });
    if (response?.data) {
      setCouponDiscount(response?.data);
      toast.success("Coupon applied successfully");
    } else {
      toast.error(error?.message || "Failed to apply coupon");
    }
    setCouponLoading(false);
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <input
          type="text"
          placeholder="Name of Cardholder"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full outline-none border border-gray-200 rounded-md px-4 py-3 text-base focus:border-gray-400 transition-colors placeholder:text-gray-400"
          required
        />
        <div className="w-full border border-gray-200 rounded-md px-4 py-3 focus-within:border-gray-400 transition-colors">
          <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
        </div>
        <input
          type="text"
          placeholder="Billing Postcode"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          className="w-full border border-gray-200 rounded-md px-4 py-3 text-base focus:border-gray-400 transition-colors placeholder:text-gray-400"
        />
        <div className="grid grid-cols-2 gap-3">
          <div className="w-full border border-gray-200 rounded-md px-4 py-3 focus-within:border-gray-400 transition-colors">
            <CardCvcElement
              options={{ ...CARD_ELEMENT_OPTIONS, placeholder: "CVC" }}
            />
          </div>
          <div className="w-full border border-gray-200 rounded-md px-4 py-3 focus-within:border-gray-400 transition-colors">
            <CardExpiryElement
              options={{ ...CARD_ELEMENT_OPTIONS, placeholder: "MM/YY" }}
            />
          </div>
        </div>
      </div>

      <div className="pt-2">
        {!showCoupon ? (
          <button
            type="button"
            onClick={() => setShowCoupon(true)}
            className="text-sm font-medium text-gray-500 hover:text-black transition-colors"
          >
            Have a voucher code?
          </button>
        ) : (
          <div className="flex gap-2 animate-in fade-in duration-300">
            <input
              type="text"
              placeholder="Add coupon code here"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              className="flex-1 border border-gray-200 rounded-md px-3 py-2 text-sm focus:border-gray-400 transition-colors"
            />
            <button
              onClick={handleApplycoupon}
              disabled={couponLoading || !coupon}
              className="px-4 py-2 bg-black text-white rounded-md text-xs font-bold disabled:bg-gray-300 transition-colors"
            >
              {couponLoading ? "..." : "Apply"}
            </button>
          </div>
        )}
      </div>

      {error && <p className="text-red-500 text-sm">{error}</p>}

      <button
        type="submit"
        disabled={
          loading ||
          !postcode ||
          !name ||
          !elements?.getElement(CardNumberElement)
        }
        className={`w-full font-bold py-4 rounded-md transition-all text-[15px] ${
          loading ||
          (postcode && name && elements?.getElement(CardNumberElement))
            ? "bg-[#000] text-[#fff] shadow-sm hover:bg-gray-900"
            : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }`}
      >
        {loading ? "Processing..." : "Start my FREE Trial"}
      </button>
    </form>
  );
};
